import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type BubbleKpiState, type BubbleKpiDataObject } from '../../types'

const initialState: BubbleKpiState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const spreadFactorSlice = createSlice({
  name: 'spreadFactor',
  initialState,
  reducers: {
    spreadFactorLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    spreadFactorUpdateAction: (state, action: PayloadAction<{ data: BubbleKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    spreadFactorErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    },
    spreadFactorResetAction: () => {
      return initialState
    }
  }
})

export const {
  spreadFactorLoadingAction,
  spreadFactorUpdateAction,
  spreadFactorErrorAction,
  spreadFactorResetAction
} = spreadFactorSlice.actions

export default spreadFactorSlice.reducer
